import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Form, Row, Col, Input, Button, Table, Tabs, Modal, Select, DatePicker, Spin} from 'antd'
import {EditOutlined, SearchOutlined, ArrowLeftOutlined, CheckOutlined, DownloadOutlined, RedoOutlined} from '@ant-design/icons'
import {getPaginationConfig} from '../../../components/pagination'
import history from '../../../routes/history'
import * as AppUrl from '../../../constants/appUrl'
import moment from 'moment'
import alertMessage from '../../../utils/alertMessage'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import MessagePayload from './MessagePayload'
import messageManagementAPI from '../../../apis/messageManagementAPI'
import UPM from '../../../constants/urlPermissionMappings'
import {withTranslation} from 'react-i18next'

const storage = window.localStorage
const {Column} = Table
const {RangePicker} = DatePicker
const {TabPane} = Tabs
const {TextArea} = Input

@inject('messageDetailStore', 'mappingManagementStore', 'uiState')
@observer
class MessageDetails extends Component {
  state = {
    isVisiable: false,
    selectedRowKeys: [],
    selectedRows: [],
    record: {},
    inboundValue: '',
    outboundValue: '',
    modalVisible: false,
    selectRecord: ''
  }

  formRef = React.createRef()

  componentDidMount() {
    const {mappingManagementStore, messageDetailStore} = this.props
    const {searchParams} = this.props?.location?.state || {}
    mappingManagementStore.onGetoutboundCustomerAction()
    mappingManagementStore.onGetinboundCustomerAction()
    if (searchParams !== undefined) {
      //status tabsValue===searchParams
      if (searchParams?.tabsValue === 'APIInformationSearch') {
        messageManagementAPI.getMessageIds(searchParams).then(idsRes => {
          messageDetailStore.changeTabsValue('identificationSearch')
          const params = {
            inboundCustomer: searchParams?.record?.inboundCustomer,
            inBoundName: searchParams?.record?.inboundName,
            outboundCustomer: searchParams?.record?.outboundCustomer,
            outBoundName: searchParams?.record?.outboundName,
            startTime: searchParams?.startTime,
            endTime: searchParams?.endTime,
            status: searchParams?.status,
            direction: searchParams?.record?.direction,
            unionKey: searchParams?.unionKey,
          }
          messageDetailStore.searchMessageOverview(params, 1, PAGE_SIZE_DEFAULT, searchParams).then(res => {
            if (res?.data?.code === 0) {
              var arr = []
              // res.data.data.records.map(item=> {return arr.push(item.outboundId)})
              if (idsRes?.data?.code === 0 && idsRes.data.data.length) {
                arr = idsRes.data.data
              }
              messageDetailStore.onChangeMessageIdList(arr)
              const params = {
                messageId: arr,
                requestId: [],
                // sapMessageId: [],
                status: searchParams?.status,
                direction: searchParams?.record?.direction,
                inboundCustomer: searchParams?.record?.inboundCustomer,
                inBoundName: searchParams?.record?.inboundName,
                outboundCustomer: searchParams?.record?.outboundCustomer,
                outBoundName: searchParams?.record?.outboundName,
              }
              this.formRef.current.setFieldsValue({
                messageId: params.messageId.length ? params.messageId.join(',') : '',
                requestId: params.requestId.length ? params.requestId.join(',') : '',
                // sapMessageId: params.sapMessageId.length ? params.sapMessageId.join(',') : '',
              })
              //messageDetailStore.onSearchMsgListAction(params,1, PAGE_SIZE_DEFAULT)
              this.setState({selectedRowKeys: [], selectedRows: []})
              messageDetailStore.onChangeSearchItem({
                messageId: params?.messageId,
                requestId: params?.requestId,
                // sapMessageId: params?.sapMessageId,
              })
            }
          })
        })
      } else if (searchParams?.tabsValue === 'identificationSearch') {
        messageDetailStore.changeTabsValue(searchParams?.tabsValue)
        const params = {
          messageId: searchParams?.messageId,
          requestId: searchParams?.requestId,
          // sapMessageId: searchParams?.sapMessageId,
          status: searchParams?.status,
          direction: searchParams?.record?.direction,
          inboundCustomer: searchParams?.record?.inboundCustomer,
          inBoundName: searchParams?.record?.inboundName,
          outboundCustomer: searchParams?.record?.outboundCustomer,
          outBoundName: searchParams?.record?.outboundName,
        }
        this.formRef.current.setFieldsValue({
          messageId: JSON.stringify(params?.messageId) === '{}' ? '' : params.messageId.join(','),
          requestId: JSON.stringify(params?.requestId) === '{}' ? '' : params.requestId.join(','),
          // sapMessageId: JSON.stringify(params?.sapMessageId) === '{}'? '' : params.sapMessageId.join(',')
        })
        messageDetailStore.onSearchMsgListAction(params, 1, PAGE_SIZE_DEFAULT)
        this.setState({selectedRowKeys: [], selectedRows: []})
      } else {
        messageDetailStore.changeTabsValue(searchParams?.tabsValue)
        const params = {
          indexName: searchParams?.indexName,
          value: searchParams?.value,
          startTime: searchParams?.startTime,
          endTime: searchParams?.endTime,
          status: searchParams?.status,
          direction: searchParams?.record?.direction,
          inboundCustomer: searchParams?.record?.inboundCustomer,
          inBoundName: searchParams?.record?.inboundName,
          outboundCustomer: searchParams?.record?.outboundCustomer,
          outBoundName: searchParams?.record?.outboundName,
        }
        this.formRef.current.setFieldsValue({
          ...params,
          createDateIndex: [moment(searchParams.startTime), moment(searchParams.endTime)]
        })
        messageDetailStore.searchMsgOverviewIndexName()
        messageDetailStore.onSearchMsgListIndexAction(params, 1, PAGE_SIZE_DEFAULT)
      }
    } else {
      this.formRef.current.setFieldsValue({
        createDate: [moment().startOf('day'), moment().endOf('day')],
        createDateIndex: [moment().add('day', -6).startOf('day'), moment().endOf('day')]
      })
      messageDetailStore.changeTabsValue('APIInformationSearch')
      //if menu enter
      this.handleSearch('APIInformationSearch')
    }
  }

  onSelectChange = (selectedRowKeys, selectedRows) => {
    this.setState({selectedRowKeys, selectedRows})
  }
  showMessageLog = (record) => {
    const {messageDetailStore} = this.props
    messageDetailStore.onSearchMessageLogAction(record.requestId)
    this.setState({isVisiable: true, record})
  }
  handlePayload = (record) => {
    const {messageDetailStore} = this.props
    const {searchItem} = messageDetailStore
    this.setState({
      modalVisible: true,
      searchItem,
      selectRecord: record
    })
  }
  handleCancel = () => {
    this.setState({
      modalVisible: false
    })
  }
  handleSearch = () => {
    const {messageDetailStore} = this.props
    const {tabsValue} = messageDetailStore
    if (tabsValue === 'APIInformationSearch') {
      this.formRef.current.validateFields().then(fieldsValue => {
        const params = {
          inboundCustomer: fieldsValue.inboundCustomer,
          inboundId: fieldsValue.inBoundName,
          outboundCustomer: fieldsValue.outboundCustomer,
          outboundId: fieldsValue.outBoundName,
          startTime: !fieldsValue.createDate[0] ? '' : moment(fieldsValue.createDate[0]).format('YYYY-MM-DD HH:mm:ss'),
          endTime: !fieldsValue.createDate[1] ? '' : moment(fieldsValue.createDate[1]).format('YYYY-MM-DD HH:mm:ss'),
        }
        messageDetailStore.searchMessageOverview(params, 1, PAGE_SIZE_DEFAULT)
      }).catch(err => {})
    } else if (tabsValue === 'identificationSearch') {
      this.formRef.current.validateFields().then(fieldsValue => {
        const params = {
          messageId: fieldsValue.messageId.length > 0 ? fieldsValue.messageId?.split(',') : [],
          requestId: fieldsValue.requestId.length > 0 ? fieldsValue.requestId?.split(',') : [],
          // sapMessageId: fieldsValue.sapMessageId.length>0?fieldsValue.sapMessageId.replace(/-/g,'')?.split(","):[],
        }
        messageDetailStore.onSearchMsgListAction(params, 1, PAGE_SIZE_DEFAULT)
      }).catch(err => {})
    } else {
      this.formRef.current.validateFields().then(fieldsValue => {
        const params = {
          apiName: '',
          direction: '',
          status: '',
          indexName: fieldsValue.indexName,
          value: fieldsValue.value,
          startTime: !fieldsValue.createDateIndex[0] ? '' : moment(fieldsValue.createDateIndex[0]).format('YYYY-MM-DD HH:mm:ss'),
          endTime: !fieldsValue.createDateIndex[1] ? '' : moment(fieldsValue.createDateIndex[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        }
        messageDetailStore.onSearchMsgListIndexAction(params, 1, PAGE_SIZE_DEFAULT)
      }).catch(err => {})
    }
    this.setState({selectedRowKeys: [], selectedRows: []})
  }

  handleRelatedSearch = (record) => {
    const {messageDetailStore} = this.props
    messageDetailStore.onSearchMsgListAction({requestId: [record.requestId],}, 1, PAGE_SIZE_DEFAULT)
    this.setState({selectedRowKeys: [], selectedRows: []})
  }

  handleResend = () => {
    const {messageDetailStore} = this.props
    const {selectedRows} = this.state
    if (selectedRows.length !== 0) {
      // this.formRef.current.validateFields().then(fieldsValue => {
      const parms = []
      const parmsScheduled = []
      const inboundError = []
      const outboundScheduled = []
      selectedRows.filter(item => item.direction === 'INBOUND' && item.status !== 'ERROR').map(it => { return inboundError.push(it)})
      selectedRows.filter(item => item.direction === 'OUTBOUND' && item.status === 'SCHEDULED').map(it => { return outboundScheduled.push(it)})
      if (inboundError.length > 0) {
        alertMessage.error('INBOUND Data status must be ERROR!')
      } else if (outboundScheduled.length > 0 && outboundScheduled.length < selectedRows.length) {
        alertMessage.error('Data status must be SCHEDULED!')
      } else {
        // selectedRows.filter(item=>item.direction==='INBOUND').map(it=> {return parms.push({
        //   direction: it.direction,
        //   requestId: it.requestId
        // })})
        // selectedRows.filter(item=>item.direction==='OUTBOUND'&&item.status !=='SCHEDULED').map(it=> {return parms.push({
        //   direction: it.direction,
        //   messageId: it.outboundId
        // })})
        // selectedRows.filter(item=>item.direction==='OUTBOUND'&&item.status ==='SCHEDULED').map(it=> {return parmsScheduled.push({
        //   "mappingName": it.mappingName,
        //   "inboundName": it.ingestionTopicName,
        //   "requestId": it.requestId,
        // })})
        selectedRows.filter(item => item.direction === 'INBOUND').map(it => {
          return parms.push({
            messageId: it.messageId
          })
        })
        selectedRows.filter(item => item.direction === 'OUTBOUND' && item.status !== 'SCHEDULED').map(it => {
          return parms.push({
            messageId: it.messageId
          })
        })
        selectedRows.filter(item => item.direction === 'OUTBOUND' && item.status === 'SCHEDULED').map(it => {
          return parms.push({
            messageId: it.messageId
          })
        })
        if (parms.length > 0) {
          messageDetailStore.onResendMsgAction({operationRequestVoList: parms}, 1).then(res => {
            this.setState({selectedRowKeys: [], selectedRows: []})
          })
        }
        // if(parmsScheduled.length>0){
        //   messageDetailStore.onResendScheduledAction({queryScheduledRequestVoList: parmsScheduled},1).then(res=>{
        //     this.setState({selectedRowKeys:[], selectedRows:[]})
        //   })
        // }

      }
      // })
    } else {
      alertMessage.error('Please select a message！')
    }
  }

  disableModal = () => {
    this.setState({isVisiable: false})
  }

  handleExport = () => {
    const {messageDetailStore, uiState} = this.props
    const {tabsValue} = messageDetailStore
    const {searchItem} = messageDetailStore
    if (tabsValue === 'APIInformationSearch') {
      uiState.onChangeFetchingExport('/monitor/messageOverview/apiInformationSearch/details/export', {...searchItem}, `Message Details List.xlsx`)
    } else if (tabsValue === 'identificationSearch') {
      uiState.onChangeFetchingExport('/monitor/messageOverview/identificationSearch/details/export', {...searchItem}, `Message Details List.xlsx`)
    } else {
      uiState.onChangeFetchingExport('/monitor/messageOverview/indexSearch/details/export', {...searchItem}, `Message Details List.xlsx`)
    }
  }

  onChangeRangePicker = (time, timeString) => {
  }
  onChange = (value) => {
    const {messageDetailStore} = this.props
    messageDetailStore.changeTabsValue(value)
    if (value === 'APIInformationSearch') {
      const params = {
        startTime: moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        endTime: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      }
      messageDetailStore.searchMessageOverview(params, 1, PAGE_SIZE_DEFAULT)
      this.formRef.current.setFieldsValue({
        inboundCustomer: undefined,
        inBoundName: undefined,
        outboundCustomer: undefined,
        outBoundName: undefined,
        createDate: [moment().startOf('day'), moment().endOf('day')],
      })
    } else if (value === 'identificationSearch') {
      const params = {
        messageId: [],
        requestId: [],
        // sapMessageId: [],
      }
      messageDetailStore.resetMessageList()
      // messageDetailStore.onSearchMsgListAction(params,1, PAGE_SIZE_DEFAULT)
      this.formRef.current.setFieldsValue(params)
    } else {
      const params = {
        apiName: '',
        direction: '',
        status: '',
        indexName: undefined,
        value: '',
        startTime: moment().add('day', -6).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        endTime: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      }
      messageDetailStore.searchMsgOverviewIndexName()
      messageDetailStore.onSearchMsgListIndexAction(params, 1, PAGE_SIZE_DEFAULT)
      this.formRef.current.setFieldsValue({
        indexName: undefined,
        value: '',
        createDateIndex: [moment().add('day', -6).startOf('day'), moment().endOf('day')]
      })
    }
  }
  /*inboundCustomer*/
  onChangeInbound = (value) => {
    const {mappingManagementStore} = this.props
    mappingManagementStore.onGetInboundNameAction(value)
    this.formRef.current.setFieldsValue({
      inBoundName: undefined
    })
    if (value === undefined) {
      this.setState({
        inboundValue: ''
      })
    } else {
      this.setState({
        inboundValue: value
      })
    }
  }
  onChangeOutbound = (value) => {
    const {mappingManagementStore} = this.props
    mappingManagementStore.onGetOutboundNameAction(value)
    this.formRef.current.setFieldsValue({
      outBoundName: undefined
    })
    if (value === undefined) {
      this.setState({
        outboundValue: ''
      })
    } else {
      this.setState({
        outboundValue: value
      })
    }
  }
  handleBack = () => {
    const {searchParams} = this.props.location.state || {}
    history.push(AppUrl.MESSAGEMANAGEMENT, {searchParams})
  }
  handleDownload = () => {
    const {uiState} = this.props
    const {selectedRows} = this.state
    if (selectedRows.length !== 0) {
      this.formRef.current.validateFields().then(fieldsValue => {
        const parms = []
        selectedRows.map(it => {
          return parms.push({
            messageId: it.messageId
          })
        })
        uiState.onChangeFetchingExport('/monitor/messageOverview/details/downloadPayload', {body: parms}, `Download Payload.zip`)
        this.setState({selectedRowKeys: [], selectedRows: []})
      }).catch(err => {})
    } else {
      alertMessage.error('Please select a message！')
      return
    }
  }

  handlePageChange = (page, pageSize) => {
    const {messageDetailStore} = this.props
    const {searchParams} = this.props?.location?.state || {}
    messageDetailStore.onChangePageNumAction(page, pageSize || 10, searchParams)
    this.setState({selectedRowKeys: [], selectedRows: []})
  }
  handlePageChangeAntd = (pageNo, pageSize) => {
    const {messageDetailStore} = this.props
    messageDetailStore.onChangePageNo(pageNo, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  render() {
    const themeStyle = JSON.parse(storage.getItem('themeStyle'))
    const {selectedRowKeys, isVisiable} = this.state
    const {messageDetailStore, mappingManagementStore, location, t} = this.props
    const {inboundCustomerList, inboundNameList, outboundCustomerList, outboundNameList} = mappingManagementStore
    const {isFetching, isFetchingLog, pageNo, pageSize, itemCount, messageList, messageLog, indexNames, tabsValue} = messageDetailStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    }
    const checkMaxLength = (rule, value, callback) => {
      if (value !== undefined && value.length > 1000) {
        callback('The input content has exceeded 1000 characters！')
      } else {
        callback()
      }
    }
    return (
      <>
        <div className="BackCon" style={{'display': this.props.location.state?.searchParams !== undefined ? 'block' : 'none'}}>
          <Button type="primary" onClick={() => this.handleBack()} icon={<ArrowLeftOutlined/>}>{t(`general.back`)}</Button>
        </div>
        <Form ref={this.formRef} className="searchForm" layout="vertical">
          <div className="searchFormTitle">
            <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
          </div>
          <Tabs
            defaultActiveKey={this.props.location.state?.searchParams?.tabsValue === 'indexSearch' ? 'indexSearch' : this.props.location.state?.searchParams?.tabsValue ? 'identificationSearch' : 'APIInformationSearch'}
            onChange={this.onChange} className="messagesTabs">
            <TabPane tab={t(`messageManagement.connectInfoSearch`)} key="APIInformationSearch" style={{paddingTop: 10}}>
              <Row gutter={[10, 0]}>
                <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
                  <Form.Item name="inboundCustomer" label={t(`messageManagement.inboundCustomer`)}
                             rules={[{message: `${t(`general.pleaseSelect`)} ${t(`messageManagement.inboundCustomer`)}`,}]}>
                    <Select placeholder={t(`general.pleaseSelect`)} allowClear onChange={this.onChangeInbound} showSearch
                            filterOption={(input, option) =>
                              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }>
                      {inboundCustomerList.length > 0 ? inboundCustomerList.map(item => <Select.Option key={item.id}
                                                                                                       value={item.id}>{item.customer}</Select.Option>) : null}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
                  <Form.Item name="inBoundName" label={t(`messageManagement.inboundName`)}
                             rules={[{message: `${t(`general.pleaseSelect`)} ${t(`messageManagement.inboundName`)}`,}]}>
                    <Select placeholder={t(`general.pleaseSelect`)} allowClear disabled={this.state.inboundValue === ''} showSearch
                            filterOption={(input, option) =>
                              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }>
                      {inboundNameList.map(item => <Select.Option key={item.id} value={item.id}>{item.apiName}</Select.Option>)}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
                  <Form.Item name="outboundCustomer" label={t(`messageManagement.outboundCustomer`)}
                             rules={[{message: `${t(`general.pleaseSelect`)} ${t(`messageManagement.outboundCustomer`)}`,}]}>
                    <Select placeholder={t(`general.pleaseSelect`)} allowClear onChange={this.onChangeOutbound} showSearch
                            filterOption={(input, option) =>
                              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }>
                      {outboundCustomerList.length > 0 ? outboundCustomerList.map(item => <Select.Option key={item.id}
                                                                                                         value={item.id}>{item.customer}</Select.Option>) : null}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
                  <Form.Item name="outBoundName" label={t(`messageManagement.outboundName`)}
                             rules={[{message: `${t(`general.pleaseSelect`)} ${t(`messageManagement.outboundName`)}`,}]}>
                    <Select placeholder={t(`general.pleaseSelect`)} allowClear disabled={this.state.outboundValue === ''} showSearch
                            filterOption={(input, option) =>
                              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }>
                      {outboundNameList.map(item => <Select.Option key={item.id} value={item.id}>{item.apiName}</Select.Option>)}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={8} xl={8} xxl={8}>
                  <Form.Item
                    name="createDate"
                    label={t(`messageManagement.timeRange`)}>
                    <RangePicker
                      showTime
                      allowClear={false}
                      format="YYYY-MM-DD HH:mm:ss"
                      onChange={this.onChangeRangePicker}
                      style={{width: '100%'}}
                    />
                  </Form.Item>
                </Col>
                <Col span={24} style={{textAlign: 'right', marginBottom: 10}}>
                  <Button htmlType="submit" style={{marginRight: 10}} onClick={this.handleSearch}
                          onKeyDown={this.handleKeyDown} type='danger'>
                    {t(`general.search`)}
                  </Button>
                  <Button style={{marginRight: 10}} type="primary" onClick={() => this.handleResend()} icon={<RedoOutlined/>}>
                    {t(`general.resend`)}
                  </Button>
                  {/*<Button style={{ marginRight: 10, width: '150px'}} type="primary" onClick={()=>this.handleDownload()}>*/}
                  {/*  Download Payload*/}
                  {/*</Button>*/}
                  <Button type="primary" onClick={this.handleExport} icon={<DownloadOutlined/>}>
                    {t(`general.export`)}
                  </Button>
                </Col>
              </Row>
            </TabPane>
            <TabPane tab={t(`messageManagement.identSearch`)} key="identificationSearch" style={{paddingTop: 10}}>
              <Row justify="start" gutter={[10, 10]}>
                <Col xs={24} sm={24} md={12} lg={12} xl={7} xxl={8}>
                  <Form.Item name="messageId" label={t(`messageManagement.messageId`)}>
                    <TextArea rows={2} placeholder={t(`general.pleaseEnter`)} allowClear/>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={7} xxl={8}>
                  <Form.Item name="requestId" label={t(`messageManagement.requestId`)}>
                    <TextArea rows={2} placeholder={t(`general.pleaseEnter`)} allowClear/>
                  </Form.Item>
                </Col>
                {/*<Col span={8} >*/}
                {/*  <Form.Item name='sapMessageId' label="SAP Message ID" labelCol={{span:7}} wrapperCol={{span:17}}*/}
                {/*             rules={[{ message: 'Please enter SAP Message ID without special characters.', pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/) }]}>*/}
                {/*             /!*rules={[{ message: 'Please enter SAP Message ID without special characters.', pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/) },{ validator: checkMaxLength}]}>*!/*/}
                {/*    <TextArea rows={2} placeholder={t(`general.pleaseEnter`)} allowClear />*/}
                {/*  </Form.Item>*/}
                {/*</Col>*/}
                <Col xs={24} sm={24} md={12} lg={12} xl={10} xxl={8} style={{textAlign: 'right', marginTop: 30}}>
                  <Button htmlType="submit" onClick={this.handleSearch} type='danger'>
                    {t(`general.search`)}
                  </Button>
                  <Button type="primary" onClick={() => this.handleResend()} icon={<RedoOutlined/>}>
                    {t(`general.resend`)}
                  </Button>
                  {/*<Button style={{ marginRight: 10, width: '150px'}} type="primary" onClick={()=>this.handleDownload()}>*/}
                  {/*  Download Payload*/}
                  {/*</Button>*/}
                  <Button type="primary" onClick={this.handleExport} icon={<DownloadOutlined/>}>
                    {t(`general.export`)}
                  </Button>
                </Col>
              </Row>
            </TabPane>
            {/*<TabPane tab="Index Search" key="indexSearch" style={{paddingTop: 10}}>*/}
            {/*  <Row>*/}
            {/*    <Col span={8} >*/}
            {/*      <Form.Item name='indexName' label="Index Name" labelCol={{span:7}} wrapperCol={{span:17}}*/}
            {/*                 rules={[{ required: tabsValue==='indexSearch', message: 'Please select Index Name.' }]}>*/}
            {/*        <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch>*/}
            {/*          {indexNames.length>0?indexNames.map(item => <Select.Option key={item} value={item}>{item}</Select.Option>):null}*/}
            {/*        </Select>*/}
            {/*      </Form.Item>*/}
            {/*    </Col>*/}
            {/*    <Col span={8} >*/}
            {/*      <Form.Item name='value' label="Index Value" labelCol={{span:7}} wrapperCol={{span:17}}*/}
            {/*                 rules={[{ required: tabsValue==='indexSearch', message: 'Please enter Index Value without special characters.', pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/) }]}>*/}
            {/*        <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} allowClear />*/}
            {/*      </Form.Item>*/}
            {/*    </Col>*/}
            {/*    <Col span={8} >*/}
            {/*      <Form.Item labelCol={{span:7}} wrapperCol={{span:17}}*/}
            {/*                 name='createDateIndex'*/}
            {/*                 label='Time Range'*/}
            {/*      >*/}
            {/*        <RangePicker*/}
            {/*          allowClear={false}*/}
            {/*          format="YYYY-MM-DD"*/}
            {/*          onChange={this.onChangeRangePicker}*/}
            {/*        />*/}
            {/*      </Form.Item>*/}
            {/*    </Col>*/}
            {/*    <Col span={24} style={{ textAlign: 'right', marginTop: 10}}>*/}
            {/*      <Button type="primary" htmlType="submit" style={{ marginRight: 10}} onClick={this.handleSearch}>*/}
            {/*        Search*/}
            {/*      </Button>*/}
            {/*      <Button style={{ marginRight: 10}} type="primary" onClick={() => this.handleResend()}>*/}
            {/*        Resend*/}
            {/*      </Button>*/}
            {/*      <Button style={{ marginRight: 10, width: '150px'}} type="primary" onClick={()=>this.handleDownload()}>*/}
            {/*        Download Payload*/}
            {/*      </Button>*/}
            {/*      <Button type="primary" onClick={this.handleExport}>*/}
            {/*        Export*/}
            {/*      </Button>*/}
            {/*    </Col>*/}
            {/*  </Row>*/}
            {/*</TabPane>*/}
          </Tabs>
        </Form>
        <Spin spinning={isFetching}>
          <Table className="searchResult" pagination={pagination} rowClassName={this.getRowClassName} rowSelection={rowSelection}
                 dataSource={messageList} rowKey="id" scroll={{x: 'max-content', scrollToFirstRowOnChange: true}}>
            <Column fixed="left" width={80} title={t(`messageManagement.status`)}
                    render={(text, record, index) =>
                      <div style={{
                        display: 'inline-block',
                        height: 24,
                        width: 24,
                        lineHeight: '24px',
                        fontSize: 12,
                        borderRadius: 24,
                        color: 'white',
                        textAlign: 'center',
                        background: record.status === 'SUCCESSFUL' ? themeStyle?.statusColor?.split(',')?.[0] || '#97cf7c' : record.status === 'ERROR' ? themeStyle?.statusColor?.split(',')?.[1] || '#ef6e6e' : record.status === 'SCHEDULED' ? themeStyle?.statusColor?.split(',')?.[2] || '#7ac3e0' : themeStyle?.statusColor?.split(',')?.[3] || '#facb61'
                      }}
                           title={record.status}>{record.status.charAt(0)}</div>
                    }
            />
            <Column fixed="left" title={t(`messageManagement.messageId`)} dataIndex="messageId"/>
            <Column title={t(`messageManagement.requestId`)} dataIndex="requestId"
                    render={(text, record, index) => <a onClick={() => this.showMessageLog(record)}>{text}</a>}/>
            {/*<Column title='SAP Message ID' dataIndex="sapMessageId" />*/}
            <Column title={t(`messageManagement.direction`)} dataIndex="direction"/>
            <Column title={t(`messageManagement.customer`)} dataIndex="customerStr"/>
            <Column title={t(`messageManagement.connectName`)} dataIndex="apiName"/>
            <Column title={t(`messageManagement.mappingName`)} dataIndex="mappingName"/>
            <Column title={t(`messageManagement.lastStep`)} dataIndex="lastStep"/>
            <Column title={t(`messageManagement.startTime`)} dataIndex="startTime"/>
            <Column title={t(`messageManagement.endTime`)} dataIndex="endTime"/>
            <Column title={t(`messageManagement.duration`)} dataIndex="duration"/>
            <Table.Column fixed="right" align="center" title={t(`general.action`)} key="Action" render={(text, record) => (
              <>
                <Button style={{marginRight: 10}} type="link" onClick={() => this.handlePayload(record)} icon={<EditOutlined/>}
                        title={t(`messageManagement.openMessage`)}/>
                <Button type="link" onClick={() => this.handleRelatedSearch(record)} icon={<SearchOutlined/>}
                        title={t(`messageManagement.relatedMessage`)}/>
              </>
            )}/>
          </Table>
          {/*{tabsValue==='APIInformationSearch' ?null:<Pagination*/}
          {/*  current={pageNo}*/}
          {/*  pageSize={pageSize}*/}
          {/*  onChange={this.handlePageChangeAntd}*/}
          {/*  total={itemCount}*/}
          {/*  showSizeChanger*/}
          {/*  showQuickJumper*/}
          {/*  showTotal={total => `共${total}条数据`}*/}
          {/*  pageSizeOptions={['10', '20', '50', '100']}*/}
          {/*  style={{marginTop: 16, paddingBottom:16, textAlign: 'right'}}*/}
          {/*/>}*/}
        </Spin>
        <Modal
          title={t(`messageManagement.messageLog`)}
          width="85%"
          visible={isVisiable}
          onCancel={this.disableModal}
          footer={null}
          destroyOnClose={true}
          centered
        >
          <Spin spinning={isFetchingLog}>
            <Table scroll={{y: 390}} tableLayout="fixed" pagination={false} rowClassName={this.getRowClassName} dataSource={messageLog} rowKey="id"
                   size="small">
              <Column title={t(`messageManagement.messageId`)} dataIndex="messageId"/>
              <Column title={t(`messageManagement.message`)} dataIndex="message" ellipsis={true}/>
              <Column title={t(`messageManagement.step`)} dataIndex="step"/>
              <Column width="70px" title={t(`messageManagement.resend`)} dataIndex="resend"
                      render={text => text !== null ? <CheckOutlined style={{color: 'green'}}/> : ''}/>
              <Column width="100px" title={t(`messageManagement.direction`)} dataIndex="directionType"/>
              <Column width="90px" title={t(`messageManagement.sequence`)} dataIndex="sequence"/>
              <Column title={t(`messageManagement.createTime`)} dataIndex="createTime"
                      render={text => text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : ''}/>
              <Column title={t(`messageManagement.endTime`)} dataIndex="endTime"
                      render={text => text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : ''}/>
            </Table>
          </Spin>
        </Modal>
        {this.state.modalVisible ? <MessagePayload
          modalVisible={this.state.modalVisible}
          handleCancel={this.handleCancel}
          selectRecord={this.state.selectRecord}
          searchItem={this.state.searchItem}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(MessageDetails)
